module.exports = __webpack_public_path__ + "static/media/lidingshanadj.a766d8b9.webp";